import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import './Loading.scss';

import { cNs } from 'src/helpers';

interface ILoadingProps {
  isGlobal?: boolean;
  width?: number | string;
  size?: number;
}

export const Loading = ({ isGlobal = true, width = 'w-100', size }: ILoadingProps) => {
  return (
    <Spin
      className={cNs(
        'loading__container',
        typeof width === 'number' ? `w-${width}` : width,
        isGlobal && 'loading__container__global'
      )}
      indicator={<LoadingOutlined style={{ fontSize: size ?? (isGlobal ? 100 : 50) }} spin />}
    />
  );
};
